import { useState } from "react";
import {
  ItemType,
  ReactionCategoryItem,
} from "../../../models/ViewModels/RecordCatalogViewModel";
import {
  AdverseReactionItem,
  AdverseReactionType,
  DrugHistoryItem,
} from "../../../models/ViewModels/RecordViewModel";
import useFetch from "../../../_services/fetch";
import { RaytebRequests } from "../../../_services";
import { ReducerType } from "../../../storeManager/ReducerType";
import { LoginInterface } from "../../../Interfaces/LoginInterface";
import { useSelector } from "react-redux";
import {
  Button,
  Icon,
  ProvideTypeahead,
  Select,
  TextBox,
  Typeahead,
} from "../../../share/Elements";
import { LoadingFit } from "../../../share/Components";
import { TextBoxTypeEnum } from "../../../enums/TextBoxTypeEnum";
import { toast } from "react-toastify";
import Card from "../../../share/Components/Card/Card";

type TypeaheadData = {
  show: boolean;
  data?: any;
};

const RecordAdverseReaction = ({
  reactions,
  severities,
  item,
  onItemChange,
}: {
  reactions?: Array<ReactionCategoryItem>;
  severities?: Array<ItemType<number>>;
  item?: AdverseReactionType;
  onItemChange?: (updatedItem: AdverseReactionType) => void; // A function to handle item changes
}) => {
  const [adverseReaction, setAdverseReaction] = useState<AdverseReactionItem>();
  const user = useSelector<ReducerType, LoginInterface>(
    (state) => state.reducerUser
  );
  const [drug, setDrug] = useState<DrugHistoryItem>();
  const drugs = useFetch<
    Array<ItemType<number>>,
    unknown,
    {
      filter: string;
    }
  >({
    request: RaytebRequests.Profile_Drugs_GET({ token: user.token }),
    onSuccess(data) { },
  });
  const getSymptom = useFetch<
    Array<ItemType<string>>,
    unknown,
    {
      filter: string;
    }
  >({
    request: RaytebRequests.Profile_GetDisease_GET({ token: user.token }),
    onSuccess(data) { },
  });
  const [showList, setshowList] = useState<TypeaheadData>({ show: false });
  const [showList2, setshowList2] = useState<TypeaheadData>({ show: false });

  const selectedItem = (item: ItemType<number>) => {
    const updatedItem: AdverseReactionItem = {
      ...drug,
      agentId: item.id,
      agent: item.title,
    };
    setAdverseReaction(updatedItem);
    setshowList({ ...showList, show: false });
  };
  const selectedItem2 = (item: ItemType<string>) => {
    const reaction = reactions?.find((r) => {
      return item.id >= r.startBlock && item.id <= r.endBlock;
    });

    const updatedItem: AdverseReactionItem = {
      ...adverseReaction,
      reactionId: item.id,
      reaction: item.title,
      reactionCategoryId: reaction?.id,
    };
    setAdverseReaction(updatedItem);
    setshowList2({ ...showList2, show: false });
  };
  const getReaction = (id: string): string | undefined => {
    const reaction = reactions?.find((r) => r.id === id);
    return reaction?.title;
  };
  const handleAddItem = () => {
    debugger;
    if (!adverseReaction?.agentId) toast.error("یک مورد انتخاب کنید");
    else if (!adverseReaction.reactionId) toast.error("یک مورد انتخاب کنید");
    else {
      const updatedItems = item?.items ? [...item.items] : [];
      updatedItems.push(adverseReaction);

      const updatedDiagnosisType: AdverseReactionType = {
        ...item,
        items: updatedItems,
      };
      onItemChange && onItemChange(updatedDiagnosisType);
      setAdverseReaction({
        description: "",
        severity: adverseReaction.severity,
      });
    }
  };
  const handleAbstractClick = (index: number) => {
    const updatedItems = [...(item?.items || [])];
    updatedItems[index] = {
      ...updatedItems[index],
      isAbstract: !updatedItems[index].isAbstract,
    };

    const checkupData: AdverseReactionType = {
      ...item,
      items: updatedItems,
    };
    onItemChange && onItemChange(checkupData);
  };
  const handleDeleteClick = (index: number) => {
    const updatedItems = [...(item?.items || [])];
    updatedItems.splice(index, 1);

    const updatedObject = { ...item, items: updatedItems };

    onItemChange && onItemChange(updatedObject);
  };
  return (
    <>
      <div className="p-6 ">
        <ProvideTypeahead
          className={`mb-1 ${true ? "before:absolute before:z-50 " : ""}`}
          showList={showList.show}
          listChildren={
            <ListChildren
              onClick={(item) => {
                selectedItem(item);
              }}
              listData={drugs.result}
              isLoading={drugs.isLoading}
              onHide={() => setshowList({ show: false })}
            />
          }
        >
          <div className="px-1 flex justify-start  items-end md:!w-1/2 md:mx-auto ">
            <Typeahead
              innerText="نام دارو ..."
              className="before:absolute before:bg-white/30 before:w-full before:h-full"
              onClick={(e) => {
                e.stopPropagation();
                e.target.select();
              }}
              // onBlur={() => setshowList({ ...showList, show: false })}
              onFocus={() => setshowList({ ...showList, show: true })}
              onChange={(e) =>
                drugs.reFetch(null, {
                  filter: e.target.value,
                })
              }
              value={adverseReaction?.agent}
            ></Typeahead>
          </div>
        </ProvideTypeahead>
        <ProvideTypeahead
          className={` mb-1 ${true ? "before:absolute before:z-50 " : ""}`}
          showList={showList2.show}
          listChildren={
            <ListChildren2
              onClick={(item) => {
                selectedItem2(item);
              }}
              listData={getSymptom.result}
              isLoading={getSymptom.isLoading}
              onHide={() => setshowList2({ show: false })}
            />
          }
        >
          <div className="px-1 flex justify-start  items-end md:!w-1/2 md:mx-auto ">
            <Typeahead
              innerText="نام بیماری"
              className="before:absolute before:bg-white/30 before:w-full before:h-full"
              onClick={(e) => {
                e.stopPropagation();
                e.target.select();
              }}
              // onBlur={() => setshowList2({ ...showList2, show: false })}
              onFocus={() => setshowList2({ ...showList2, show: true })}
              onChange={(e) =>
                getSymptom.reFetch(null, {
                  filter: e.target.value,
                })
              }
              value={adverseReaction?.reaction}
            ></Typeahead>
          </div>
        </ProvideTypeahead>
        <div className="mb-1 mt-4 md:!w-1/2 md:mx-auto">
          <TextBox
            className={`w-full h-9 ${adverseReaction?.reactionCategoryId ? "" : "hidden"
              }`}
            Regular=""
            RxgMessage=""
            debounceTime={0}
            innerText="دسته بندی عارضه"
            isRequired={false}
            disabled={true}
            Type={TextBoxTypeEnum.Text}
            value={
              reactions?.find(
                (r) => r.id === adverseReaction?.reactionCategoryId
              )?.title || ""
            }
          />
          <Select
            className={`mt-1 w-full h-9 `}
            onChange={(e) => {
              if (e.target.value && e.target.value !== "") {
                setAdverseReaction({
                  ...adverseReaction,
                  severity: Number(e.target.value),
                });
              }
            }}
            value={
              severities?.find((r) => r.id === adverseReaction?.severity)
                ?.title || ""
            }
          >
            {severities?.map((n, i) => (
              <option key={i} value={n.id}>
                {n.title}
              </option>
            ))}
          </Select>
        </div>
        <div className="mt-4 grid grid-cols-9 gap-1">
          <div className="col-span-8">
            <TextBox
              innerText="توضیحات"
              debounceTime={0}
              className="w-full "
              Type={TextBoxTypeEnum.Text}
              value={adverseReaction?.description}
              onChange={(e) =>
                setAdverseReaction({
                  ...adverseReaction,
                  description: e.target.value,
                })
              }
            />
          </div>
        </div>
        <div className="flex justify-between items-center mt-3 px-1">
          <Icon
            icon="rayteb-add-circular cursor-pointer"
            className="text-xl mr-auto text-primaryLight"
            onClick={handleAddItem}
          />
        </div>
        <div className="mt-5 grid grid-cols-1 gap-1 ">
          {item?.items?.map((n, i) => (
            <Card
              text={n.agent}
              footer={
                <CardFooter
                  items={n}
                  onAbstractClick={() => handleAbstractClick(i)}
                  onDeleteClick={() => handleDeleteClick(i)}
                />
              }
            >
              <span className="text-[9px] text-primaryLight ml-1  font-bold">
                {n.reaction} (
                {reactions?.find((r) => r.id === n.reactionCategoryId)?.title ||
                  ""}
                ),
              </span>
              <br />
              <span className="text-[9px] text-primaryLight pr-1">
                {severities?.find((r) => r.id === n.severity)?.title || ""}
              </span>
            </Card>
          ))}
        </div>
      </div>
    </>
  );
};
type ListChildrenType = {
  listData?: Array<ItemType<number>>;
  className?: string | undefined;
  isLoading: boolean;
  onHide?: () => void;
  onClick?: (param: ItemType<number>) => void;
};
const ListChildren: React.FC<ListChildrenType> = ({
  className,
  listData,
  isLoading,
  onClick,
  onHide,
}) => {
  return (
    <>
      <div>
        <LoadingFit isLoading={isLoading} />
        <div className="border-b border-disable bg-white py-2 px-1 flex items-center">
          <Icon
            icon="rayteb-android-close"
            className="text-xl"
            onClick={() => onHide?.()}
          />

          <p className="text-xs mr-2 font-bold text-warn ">نام دارو ...</p>
        </div>

        <div className="h-64 overflow-y-auto">
          <ul
            className={`flex justify-center flex-col  
           items-center p-2 shadow-sm ${className ?? ""}`}
          >
            {listData?.map((n, i) => (
              <li
                key={i}
                className="flex justify-start items-center h-8  py-1 w-full hover:bg-primaryDefault hover:cursor-pointer "
                onClick={(e) => {
                  e.stopPropagation();
                  onClick?.(n);
                }}
              >
                <p className="text-xs font-bold text-end text-primaryLight">
                  {n.title}
                </p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};

type ListChildrenType2 = {
  listData?: Array<ItemType<string>>;
  className?: string | undefined;
  isLoading: boolean;
  onHide?: () => void;
  onClick?: (param: ItemType<string>) => void;
};
const ListChildren2: React.FC<ListChildrenType2> = ({
  className,
  listData,
  isLoading,
  onClick,
  onHide,
}) => {
  return (
    <>
      <div>
        <LoadingFit isLoading={isLoading} />
        <div className="border-b border-disable bg-white py-2 px-1 flex items-center">
          <Icon
            icon="rayteb-android-close"
            className="text-xl"
            onClick={() => onHide?.()}
          />

          <p className="text-xs mr-2 font-bold text-warn ">علائم بیماری ...</p>
        </div>

        <div className="h-64 overflow-y-auto">
          <ul
            className={`flex justify-center flex-col  
           items-center p-2 shadow-sm ${className ?? ""}`}
          >
            {listData?.map((n, i) => (
              <li
                key={i}
                className="flex justify-start items-center h-8  py-1 w-full hover:bg-primaryDefault hover:cursor-pointer "
                onClick={(e) => {
                  e.stopPropagation();
                  onClick?.(n);
                }}
              >
                <p className="text-xs font-bold text-end text-primaryLight">
                  {n.title}
                </p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};
const CardFooter = ({
  items,
  onAbstractClick,
  onDeleteClick,
}: {
  items?: AdverseReactionItem;
  onAbstractClick: () => void;
  onDeleteClick: () => void;
}) => (
  <>
    <div className="w-full flex justify-between items-center py-3">
      <div className="bg-white  py-1 text-xs text-primary">
        {items?.description!}
      </div>

      <div className="flex justify-center itmes-center gap-2">
        <Icon
          icon="rayteb-delete"
          className="text-xl text-primary"
          onClick={onDeleteClick}
        />
        <Icon
          icon="rayteb-medical-ophthalmology"
          className={`text-xl  ${items?.isAbstract ? "text-primary" : "text-disable"
            }`}
          onClick={onAbstractClick}
        />
      </div>
    </div>
  </>
);
export default RecordAdverseReaction;
